import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import { Provider as StoreProvider } from 'react-redux';
import { ThemeProvider } from '@material-ui/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { renderRoutes } from 'react-router-config';
import theme from './theme';
import routes from './routes';
import {
  ScrollReset,
  GoogleAnalytics,
  Snackbar
} from './components';
import './mixins/moment';
import './mixins/validate';
import './mixins/prismjs';
import './assets/css/index.css';
import env from './env'
import Dialog401 from './components/Dialog401';
import ConfirmationDialog from './components/ConfirmationDialog';
import TextareaDialog from './components/TextareaDialog';
import ErrorBoundary from './utils/ErrorBoundary'
import store from 'store';

const App = () => {
  return (
    <StoreProvider store={store}>
      <ThemeProvider theme={theme}>
        <ErrorBoundary>
          <MuiPickersUtilsProvider
            libInstance={moment}
            locale="en"
            utils={MomentUtils}
          >
            <BrowserRouter basename={env.baseRoute}>
              <ScrollReset />
              <GoogleAnalytics />
              <Snackbar />
              <Dialog401 />
              <ConfirmationDialog />
              <TextareaDialog />
              {renderRoutes(routes)}
            </BrowserRouter>
          </MuiPickersUtilsProvider>
        </ErrorBoundary>
      </ThemeProvider>
    </StoreProvider>
  );
};

export default App;
